import type { BoxProps } from '@mui/material';
import { Box, useTheme } from '@mui/material';
import type { FC } from 'react';
import { PortableText } from '~/components/atoms/PortableText';
import type { TextContentProps } from '~/types/sanity/components';
import { isPortableTextBlockArray } from '~/utils/portableTextUtils';

type Props = Omit<TextContentProps, '_key' | '_type'> & { containerProps?: BoxProps };

export const TextContent: FC<Props> = ({ text, containerProps }) => {
  const theme = useTheme();

  return (
    <Box component="section">
      <Box maxWidth={theme.spacing(75)} mx="auto" px={2.5} py={4} {...(containerProps && containerProps)}>
        {isPortableTextBlockArray(text) && <PortableText portableText={text} />}
      </Box>
    </Box>
  );
};
